import SelectBillingDivision from './select-billing-division.container';

export default SelectBillingDivision;
